var map = {
	"./3djake_niceabs_natural.jpg": "e9f5",
	"./Amazon_Red.jpg": "6143",
	"./Filatech_luminous_orange.jpg": "b302",
	"./GEEtech_apple_green.JPG": "37c5",
	"./GEEtech_black.JPG": "58ae",
	"./GEEtech_blue.JPG": "b375",
	"./GEEtech_green.JPG": "7933",
	"./GEEtech_grey.JPG": "e950",
	"./GEEtech_pink.JPG": "a82a",
	"./GEEtech_violett.JPG": "4202",
	"./GEEtech_water_blue.JPG": "4097",
	"./GEEtech_yellow.JPG": "fe09",
	"./sunlu_black.jpg": "8683"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2ae5";